import { twMerge } from 'tailwind-merge';

const CLASS_NAME_BY_TYPE = {
  head: 'text-base-1000 text-[14px]/[20px] font-medium px-3 py-2.5 -tracking-[.01em]',
  total: 'text-base-1000 text-[14px]/[20px] font-medium p-3 -tracking-[.01em]',
  body: 'text-base-1000 text-[16px]/[24px] p-3 -tracking-[.01em] truncate',
};

export const Cell = ({ title, className, type }) => (
  <div title={title} className={twMerge(CLASS_NAME_BY_TYPE[type], className)}>
    {title}
  </div>
);
